import React, { Fragment } from "react";
import styled from "styled-components";

const Label = styled.label`
  padding-right: 20px;
  input {
    margin-right: 5px;
  }
`;

export default function ScheduledFilter({ value, onChange }) {
  const handleOptionChange = changeEvent => {
    onChange(changeEvent.target.value);
  };

  return (
    <Fragment>
      <br />
      <Label>
        <input
          type="radio"
          name="scheduledStatus"
          value="all"
          checked={value === "all"}
          onChange={handleOptionChange}
        />
        All &nbsp;
      </Label>
      <Label>
        <input
          type="radio"
          name="scheduledStatus"
          value="scheduled"
          checked={value === "scheduled"}
          onChange={handleOptionChange}
        />
        Yes &nbsp;
      </Label>
      <Label>
        <input
          type="radio"
          name="scheduledStatus"
          value="unscheduled"
          checked={value === "unscheduled"}
          onChange={handleOptionChange}
        />
        No
      </Label>
    </Fragment>
  );
}
